import {writable} from 'svelte/store';

const content = {incoming: []};
let notification = writable(content);

notification.add = async (type, data) => {
	console.log(type);
	if(type == 'incoming')
		content.incoming.push({id: data?.conferenceName, type, conferenceName: data?.conferenceName, contactId: data?.contactId, contactName: data?.contactName});
	if(type == 'incoming-agent')
		content.incoming.push({id: data?.conferenceName, type, conferenceName: data?.conferenceName, agentId: data?.agentId, agentName: data?.agentName});
	if(type == 'incoming-forward')
		content.incoming.push({id: data?.conferenceName, type, conferenceName: data?.conferenceName, contactId: data?.contactId, contactName: data?.contactName, agentName: data.agentName});

	notification.set(content);
}

notification.remove = async (type, id) => {
	if(content[type]) {
		content[type] = content[type].filter(item => item.id != id);
		notification.set(content);
	}
}

notification.removeIncoming = (data) => {
	const conferenceName = data?.conferenceName;
	content.incoming = content.incoming.filter(item => conferenceName != item.conferenceName)
	notification.set(content);
}

notification.removeAgent = () => {
	content.incoming = content.incoming.filter(item => item.type != 'incoming-agent');
	notification.set(content);
};

notification.clear = () => {
	content.incoming = [];
	notification.set(content);
}

export default notification;